import { render, staticRenderFns } from "./vipDisposition.vue?vue&type=template&id=1cb05466&scoped=true"
import script from "./vipDisposition.vue?vue&type=script&lang=ts"
export * from "./vipDisposition.vue?vue&type=script&lang=ts"
import style0 from "./vipDisposition.vue?vue&type=style&index=0&id=1cb05466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb05466",
  null
  
)

export default component.exports